import { css } from '@/styled-system/css';

export const entryPoint = css({
  alignItems: 'center',
  backgroundColor: 'bg.softest',
  borderRadius: 'md',
  color: 'text.neutral',
  cursor: 'pointer',
  display: 'flex',
  fontSize: 'body-sm',
  gap: 'tighter',
  lineHeight: 'body-sm',
  minWidth: 0,
  paddingBlock: 'tighter',
  paddingInline: 'default',
  textDecoration: 'none',
  width: '100%',
  _hover: {
    backgroundColor: 'bg.action.neutral.alt.hover',
  },
  _active: {
    backgroundColor: 'bg.action.neutral.alt.pressed',
  },
  focusOutline: true,
});

export const entryPointContent = css({
  alignItems: 'center',
  display: 'flex',
  flex: '1',
  gap: 'tighter',
  minWidth: 0,
  overflow: 'hidden',
  whiteSpace: 'nowrap',
});

export const ratingGroup = css({
  alignItems: 'center',
  display: 'inline-flex',
  flexShrink: 0,
  gap: 'micro.default',
});

export const ratingStar = css({
  color: 'icon.accent.yellow.hero',
});

export const ratingValue = css({
  fontWeight: 'bold',
});

export const reviewCount = css({
  color: 'text.subtle',
});

export const sourceDivider = css({
  alignSelf: 'stretch',
  borderInlineStartColor: 'border.neutral',
  borderInlineStartStyle: 'solid',
  borderInlineStartWidth: 'default',
  flexShrink: 0,
});

export const sourceMarks = css({
  alignItems: 'center',
  display: 'inline-flex',
  flexShrink: 0,
  gap: 'micro.default',
});

export const entryPointLabel = css({
  minWidth: 0,
  overflow: 'hidden',
  textOverflow: 'ellipsis',
});

export const entryPointLabelStrong = css({
  fontWeight: 'bold',
  minWidth: 0,
  overflow: 'hidden',
  textOverflow: 'ellipsis',
});

export const entryPointChevron = css({
  color: 'text.subtle',
  flexShrink: 0,
  marginInlineStart: 'auto',
});

export const shell = css({
  containerType: 'inline-size',
  containerName: 'apartment-reviews',
  backgroundColor: 'bg.neutral',
  color: 'text.neutral',
  display: 'flex',
  flexDirection: 'column',
  gap: 'default',
  scrollMarginTop: 'calc(var(--search-header-height, 0px) + {spacing.looser})',
  width: '100%',
  paddingBlock: 'looser',
  borderBottomWidth: 'default',
  borderBottomStyle: 'solid',
  borderBottomColor: 'border.neutral',
});

export const shellTitle = css({
  margin: 0,
});

export const tabRoot = css.raw({
  width: '100%',
  '& [role="tab"]': {
    flex: '1 1 0',
    minWidth: 0,
    paddingInline: 'tightest',
    height: '1000',
    fontSize: 'body-sm',
    whiteSpace: 'nowrap',
  },
});

export const tabLabel = css({
  '@container apartment-reviews (max-width: 20em)': {
    flexDirection: 'column',
    fontSize: 'body-sm',
    lineHeight: 'body-sm',
  },
  textAlign: 'center',
  alignItems: 'center',
  display: 'flex',
  minWidth: 0,
  gap: 'tighter',
});

export const panel = css({
  minWidth: 0,
  width: '100%',
});

export const providerState = css({
  alignItems: 'center',
  backgroundColor: 'bg.softest',
  borderRadius: 'md',
  display: 'flex',
  flexDirection: 'column',
  gap: 'default',
  justifyContent: 'center',
  minHeight: '2600',
  padding: 'layout.loose',
  textAlign: 'center',
});

export const providerStateMessage = css({
  color: 'text.subtle',
  fontSize: 'body-sm',
  lineHeight: 'body-sm',
  margin: 0,
});
